import { styled } from '@mui/material/styles'
import Card, { CardProps } from '@mui/material/Card'
import CardHeader, { CardHeaderProps } from '@mui/material/CardHeader'
import CardContent, { CardContentProps } from '@mui/material/CardContent'
import CardActions, { CardActionsProps } from '@mui/material/CardActions'
import CardActionArea, {
  CardActionAreaProps,
} from '@mui/material/CardActionArea'

export const StyledCard = styled(Card)<CardProps>(() => ({
  display: 'flex',
  flexDirection: 'column',
  borderRadius: '2.0rem',
}))

export const StyledCardHeader = styled(CardHeader)<CardHeaderProps>(() => ({
  padding: '2.8rem',
  paddingBottom: '2.8rem',
}))

export const StyledCardContent = styled(CardContent)<CardContentProps>(() => ({
  flex: 1,
  padding: 0,
  paddingLeft: '2.8rem',
  paddingRight: '2.8rem',
  '&:last-child': {
    paddingBottom: '2.8rem',
  },
}))

export const StyledCardActions = styled(CardActions)<CardActionsProps>(() => ({
  padding: '2.8rem',
}))

export const StyledCardActionArea = styled(CardActionArea)<CardActionAreaProps>(
  () => ({
    '&:hover .MuiCardActionArea-focusHighlight': {
      opacity: 0,
    },
  })
)
